import { render, staticRenderFns } from "./MainBottom.vue?vue&type=template&id=5812374a&scoped=true&"
import script from "./MainBottom.vue?vue&type=script&lang=js&"
export * from "./MainBottom.vue?vue&type=script&lang=js&"
import style0 from "./MainBottom.vue?vue&type=style&index=0&id=5812374a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5812374a",
  null
  
)

export default component.exports